import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  organisationSectionSchema,
  organisationSectionListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/organisationSections/actions';
import { OrganisationSectionsActionTypes as types } from 'app/ducks/organisationSections/types';

function* createOrganisationSectionSaga(action): any {
  yield put(sagaActions.createOrganisationSectionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSections.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationSectionSchema);

    yield put(sagaActions.createOrganisationSectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOrganisationSectionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateOrganisationSectionSaga(action): any {
  yield put(sagaActions.updateOrganisationSectionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSections.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationSectionSchema);

    yield put(sagaActions.updateOrganisationSectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateOrganisationSectionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getOrganisationSectionSaga(action): any {
  yield put(sagaActions.getOrganisationSectionPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSections.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, organisationSectionSchema);
    yield put(sagaActions.getOrganisationSectionSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationSections[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrganisationSectionFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllOrganisationSectionsSaga(action): any {
  yield put(
    sagaActions.getAllOrganisationSectionsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.organisationSections.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationTags.organisationList(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      organisationSectionListSchema,
    );

    yield put(
      sagaActions.getAllOrganisationSectionsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrganisationSectionsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createOrganisationSectionSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_ORGANISATION_SECTION_REQUESTED,
    createOrganisationSectionSaga,
  );
}

function* updateOrganisationSectionSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_ORGANISATION_SECTION_REQUESTED,
    updateOrganisationSectionSaga,
  );
}

function* getOrganisationSectionSagaWatcher(): any {
  yield takeLatest(
    types.GET_ORGANISATION_SECTION_REQUESTED,
    getOrganisationSectionSaga,
  );
}

function* getAllOrganisationSectionsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORGANISATION_SECTIONS_REQUESTED,
    getAllOrganisationSectionsSaga,
  );
}

export default function* root(): any {
  yield all([
    createOrganisationSectionSagaWatcher(),
    updateOrganisationSectionSagaWatcher(),
    getOrganisationSectionSagaWatcher(),
    getAllOrganisationSectionsSagaWatcher(),
  ]);
}
